import { GenericObject } from "utility/misc";

import slackConfig from "./config";

// -----------------------------------------------------------------------------

// slack requires SSL.
// you'll need to manually rewrite to http:// when using localhost.
const redirectAddress =
  process.env.REACT_APP_ENVIRONMENT === "production"
    ? `${window.location.origin}`
    : "https://localhost:3000";

export default function redirectToSlackOauthUrl(
  orgStore: GenericObject,
  navigate: Function
): void {
  const params = new URLSearchParams({
    client_id: slackConfig.clientId,
    redirect_uri: encodeURI(
      `${redirectAddress}/environment/destinations/slack/redirect`
    ),
    scope: [
      "im:read,im:write,channels:read,chat:write,groups:read,team:read,users:read.email,users:read",
    ],
    state: orgStore.uuid,
    response_type: "code",
  } as any).toString();
  const oauthURL: string = `https://slack.com/oauth/v2/authorize?${params}`;

  //
  // nosemgrep: javascript.browser.security.open-redirect.js-open-redirect
  window.location.href = oauthURL;
}
